import type { ReactNode } from 'react'
import { ArrowUpDown, ArrowUp, ArrowDown } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

interface SortHeaderProps {
  children: ReactNode
  onClick: () => void
  className?: string
  /** Columna actualmente ordenada: resalta el label y muestra la dirección. */
  active?: boolean
  /** Dirección del orden. Si se pasa, el icono refleja asc/desc en la columna activa. */
  direction?: 'asc' | 'desc'
}

export function SortHeader({ children, onClick, className, active = false, direction }: SortHeaderProps) {
  const controlled = direction !== undefined
  const Icon = active && direction === 'asc' ? ArrowUp : active && direction === 'desc' ? ArrowDown : ArrowUpDown
  return (
    <Button
      variant="ghost"
      onClick={onClick}
      className={cn('h-8 px-2 font-medium hover:bg-muted', active && 'text-foreground', className)}
    >
      {children}
      <Icon className={cn('ml-2 h-4 w-4', controlled && !active && 'opacity-40')} />
    </Button>
  )
}
